import { Pipe, PipeTransform, SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { marked } from "marked";

@Pipe({
  name: "markdownParser",
})
export class MarkdownParserPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): string {
    const renderer = new marked.Renderer();
  
    renderer.link = ({ href, title, text }) => {
      const t = title ? ` title="${title}"` : '';
      return `<a href="${href}"${t} target="_blank" rel="noopener">${text}</a>`;
    };

    return (
      this.sanitizer.sanitize(
        SecurityContext.HTML,
        marked.parse(value.replace(/\n(?=\n)/g, "\n\n<br/>\n"), { renderer }) as string
      ) || ""
    );
  }
}
